<template>
  <canvas ref="gaugeContainer" class="canvas-gauges" />
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import { RadialGauge } from "canvas-gauges";
import { RadialGaugeOptions } from "@/types/RadialGaugeOptions";

const props = defineProps<{
  value: number;
  options: RadialGaugeOptions;
}>();

const chart = ref<RadialGauge>();
const gaugeContainer = ref();

onMounted(() => {
  chart.value = new RadialGauge(
    Object.assign(props.options, {
      renderTo: gaugeContainer.value,
      value: props.value,
    }),
  ).draw();
});

onBeforeUnmount(() => {
  if (chart.value) {
    chart.value.destroy();
  }
});

watch(
  () => props.value,
  (newValue) => {
    if (chart.value) {
      chart.value.value = newValue;
    }
  },
);

// Watch for changes in `options` prop to recreate the gauge with new options
watch(
  () => props.options,
  (newOptions) => {
    if (chart.value) {
      chart.value.destroy();
    }
    chart.value = new RadialGauge(
      Object.assign({}, newOptions, {
        renderTo: gaugeContainer.value,
        value: props.value,
      }),
    ).draw();
  },
);
</script>
